
const DUMMY_GAME_DETAILS = {
  wantedChain: null,
  decimals: 0,
  tickerSymbol: '',
  logo: '',
  contract: null,
  contractReferrals: null,
  helper: null,
}


export const _GLOBAL_NAMESPACE = window.dogebets = {
  web3instances: {
    bsc: {
      http: null,
      userWallet: null
    }
  },
};